<button container="body" [ngClass]="classes" [tooltip]="disableTooltip ? undefined : tooltip">
  {{ phase }}
</button>
